// ============================================================================
// HEBREW TRANSLATIONS - BIBLE VERSES
// ============================================================================
// פסוקי תנ"ך בעברית עם מספרי סטרונג

export const bibleVersesHe = [
  {
    reference: "פיליפים 4:13",
    text: "הַכֹּל אוּכַל בַּמָּשִׁיחַ הַמְחַזְּקֵנִי",
    version: "תרגום חדש",
    theme: "כוח",
    strongNumbers: {
      "אוּכַל": "G2480", // ἰσχύω (ischyo) = יכול
      "הַמְחַזְּקֵנִי": "G1743" // ἐνδυναμόω (endynamoo) = מחזק
    },
    context: "פאולוס מדבר על הכוח שאנו מקבלים במשיח בכל נסיבות החיים"
  },
  {
    reference: "תהלים 23:1",
    text: "יְהוָה רֹעִי לֹא אֶחְסָר",
    version: "תנ\"ך",
    theme: "אמון",
    strongNumbers: {
      "רֹעִי": "H7462", // רָעָה (ra'ah) = רועה
      "אֶחְסָר": "H2637" // חָסֵר (chaser) = חסר
    },
    context: "דוד מביע את אמונו בהשגחת ה' עלינו"
  },
  {
    reference: "יוחנן 3:16",
    text: "כִּי כָּכָה אָהַב אֱלֹהִים אֶת הָעוֹלָם עַד כִּי נָתַן אֶת בְּנוֹ הַיָּחִיד לְמַעַן כָּל הַמַּאֲמִין בּוֹ לֹא יֹאבַד כִּי אִם יִהְיֶה לּוֹ חַיֵּי עוֹלָם",
    version: "תרגום חדש",
    theme: "אהבה",
    strongNumbers: {
      "אָהַב": "G25", // ἀγαπάω (agapao) = אוהב ללא תנאי
      "נָתַן": "G1325", // δίδωμι (didomi) = נותן
      "עוֹלָם": "G166" // αἰώνιος (aionios) = נצחי
    },
    context: "ישוע מגלה את אהבת אלוהים הבלתי מוגבלת אלינו"
  },
  {
    reference: "רומים 8:28",
    text: "וְיָדַעְנוּ כִּי לְאֹהֲבֵי אֱלֹהִים הַכֹּל יַחְדָּו יִפְעַל לְטוֹבָה לַנִּקְרָאִים כְּפִי תָכְנִיתוֹ",
    version: "תרגום חדש",
    theme: "השגחה",
    strongNumbers: {
      "יַחְדָּו": "G4903", // συνεργέω (synergeo) = פועלים יחד
      "לְטוֹבָה": "G18" // ἀγαθός (agathos) = לטוב
    },
    context: "פאולוס מאשר את ההשגחה הריבונית והמטרה של אלוהים"
  },
  {
    reference: "משלי 3:5-6",
    text: "בְּטַח אֶל יְהוָה בְּכָל לִבֶּךָ וְאֶל בִּינָתְךָ אַל תִּשָּׁעֵן. בְּכָל דְּרָכֶיךָ דָעֵהוּ וְהוּא יְיַשֵּׁר אֹרְחֹתֶיךָ",
    version: "תנ\"ך",
    theme: "חוכמה",
    strongNumbers: {
      "בְּטַח": "H982", // בָּטַח (batach) = בוטח
      "בִּינָתְךָ": "H998", // בִּינָה (binah) = הבנה
      "יְיַשֵּׁר": "H3474" // יָשַׁר (yashar) = מיישר
    },
    context: "שלמה מעודד אותנו לבטוח באלוהים יותר מאשר בחכמתנו שלנו"
  },
  {
    reference: "ישעיהו 40:31",
    text: "וְקוֹיֵי יְהוָה יַחֲלִיפוּ כֹחַ יַעֲלוּ אֵבֶר כַּנְּשָׁרִים יָרוּצוּ וְלֹא יִיגָעוּ יֵלְכוּ וְלֹא יִיעָפוּ",
    version: "תנ\"ך",
    theme: "התחדשות",
    strongNumbers: {
      "קוֹיֵי": "H6960", // קָוָה (qavah) = מקווים
      "יַחֲלִיפוּ": "H2498", // חָלַף (chalaph) = מתחדש
      "כֹחַ": "H3581" // כֹּחַ (koach) = כוח
    },
    context: "ישעיהו מבטיח התחדשות רוחנית למי שמקווים לה'"
  },
  {
    reference: "מתי 11:28",
    text: "בֹּאוּ אֵלַי כָּל הַיְּגֵעִים וַעֲמוּסֵי הַמַּשָּׂא וַאֲנִי אָנִיחַ לָכֶם",
    version: "תרגום חדש",
    theme: "מנוחה",
    strongNumbers: {
      "הַיְּגֵעִים": "G2872", // κοπιάω (kopiao) = עייפים
      "עֲמוּסֵי הַמַּשָּׂא": "G5412", // φορτίζω (phortizo) = עמוסים
      "אָנִיחַ": "G373" // ἀναπαύω (anapauo) = אניח
    },
    context: "ישוע מפנה הזמנה רחומה לכל העייפים"
  }
];

export default bibleVersesHe;
